import { render, staticRenderFns } from "./DirectorDeck3D.vue?vue&type=template&id=5a2bc4b6"
import script from "./DirectorDeck3D.vue?vue&type=script&lang=js"
export * from "./DirectorDeck3D.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports